import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import SUGMDTabs from './SUGMDTabs';

const {Paragraph} = Typography;
const Content = Layout;

const SUGMD = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX']}}>Software usage guide</Paragraph>
      </Content>
      <SUGMDTabs/>
      <Divider/>
    </Layout>
  );
};

export default SUGMD;
